import { AUTH } from "../const/actionsTypes";
import * as api from "../../api/index";
import { toast } from 'react-toastify';

// Load user from localStorage into Redux
export const loadUser = () => async (dispatch) => {
    try {
        const localUser = JSON.parse(localStorage.getItem("user_info"));
        if (localUser) {
            dispatch({ type: AUTH, data: localUser });
        }
    } catch (err) {
        console.error("Error loading user from localStorage:", err);
    }
};

// Normal email/password login
export const signin = (formData, navigate, onSuccess) => async (dispatch) => {
    try {
        const { data } = await api.signIn(formData); // API must return { result: { _id, ... }, token }

        // ✅ Save full response to localStorage
        localStorage.setItem("user_info", JSON.stringify(data));

        // ✅ Dispatch to Redux
        dispatch({ type: AUTH, data });

        if (onSuccess) {
            onSuccess(data);
        } else if (navigate) {
            navigate("/dashboard");
        }
        
        toast.success("Login successful!");
    } catch (err) {
        const errorMessage = err.response?.data?.message || "Login failed";
        const isExpired = err.response?.data?.isExpired;
        const email = err.response?.data?.email;

        console.error("Login error:", errorMessage);

        if (isExpired) {
            const expiredErr = new Error(errorMessage);
            expiredErr.isExpired = isExpired;
            expiredErr.email = email;
            throw expiredErr;
        }

        toast.error(errorMessage);
        throw err; // Re-throw to be caught in component
    }
};

export const resendVerification = (email) => async (dispatch) => {
    try {
        await api.resendVerification(email);
        toast.success("Verification email sent! Please check your inbox.");
    } catch (err) {
        const errorMessage = err.response?.data?.message || "Failed to resend verification email.";
        console.error("Resend verification error:", errorMessage);
        toast.error(errorMessage);
    }
};

export const signinGoogle = (tokenObj, navigate, onSuccess) => async (dispatch) => {
    try {
        // tokenObj = { googleAccessToken: "..." }
        const { data } = await api.signInGoogle(tokenObj); // POST to /users/signin

        localStorage.setItem("user_info", JSON.stringify(data));
        dispatch({ type: AUTH, data });

        if (onSuccess) {
            onSuccess(data);
        } else if (navigate) {
            navigate("/dashboard");
        }
        
        toast.success("Google login successful!");
    } catch (err) {
        const errorMessage = err.response?.data?.message || "Google login failed";
        console.error("Google login error:", errorMessage);
        toast.error(errorMessage);
    }
};


// Signup (email/password)
export const signup = (formData, navigate, redirectPath = "/dashboard") => async (dispatch) => {
    try {
        const { data } = await api.signUp(formData); // API should return { result: { _id, ... }, token }

        // ✅ Save full response
        localStorage.setItem("user_info", JSON.stringify(data));

        dispatch({ type: AUTH, data });
        navigate(redirectPath);
        toast.success("Signup successful! You are now logged in.");
    } catch (err) {
        const errorMessage = err.response?.data?.message || "Signup failed";
        console.error("Signup error:", errorMessage);
        toast.error(errorMessage);
    }
};

// Google signup
export const signupGoogle = (accessToken, navigate, redirectPath = "/dashboard") => async (dispatch) => {
    try {
        const { data } = await api.signUpGoogle(accessToken);

        // ✅ Save full response
        localStorage.setItem("user_info", JSON.stringify(data));

        dispatch({ type: AUTH, data });
        navigate(redirectPath);
        toast.success("Google signup successful!");
    } catch (err) {
        const errorMessage = err.response?.data?.message || "Google signup failed";
        console.error("Google signup error:", errorMessage);
        toast.error(errorMessage);
    }
};

// Verify email
export const verifyEmail = (token) => async (dispatch) => {
    try {
        await api.verifyEmail(token);
        toast.success("Email verified! You can now log in.");
    } catch (error) {
        toast.error("Verification failed. Token might be invalid or expired.");
    }
};


